import { useMutation, useQueryClient } from '@tanstack/react-query';
import { auditLogApi } from '../api/auditLogApi';

/**
 * 감사 로그 다중/단건 삭제 mutation hook (#453 / #454 UAT 2026-05-14 r2).
 * - 다중: POST /api/eraf/audit-logs/bulk-delete  body {ids: number[]}
 * - 단건: ids=[id] 로 동일 endpoint 호출
 * 권한: AUDIT_DELETE (ROLE_ADMIN 만 매핑).
 */
export function useBulkDeleteAuditLogs() {
  const queryClient = useQueryClient();
  return useMutation<{ deletedCount: number }, { code?: string; message?: string }, number[]>({
    mutationFn: (ids: number[]) => auditLogApi.bulkDelete(ids),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['audit-log'] });
    },
  });
}

/**
 * 단건 삭제 mutation hook (#454 UAT 2026-05-14 r2 · 상세 화면 [삭제] 버튼).
 * 내부 endpoint 는 DELETE /api/eraf/audit-logs/{id} 사용.
 */
export function useDeleteOneAuditLog() {
  const queryClient = useQueryClient();
  return useMutation<{ deletedCount: number }, { code?: string; message?: string }, number>({
    mutationFn: (id: number) => auditLogApi.deleteOne(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['audit-log'] });
    },
  });
}
